import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;

export function useConfig() {
  const [config, setConfig] = useState(cached);
  useEffect(() => {
    if (cached) return;
    api.get("/config").then((r) => { cached = r.data; setConfig(r.data); }).catch(() => {});
  }, []);
  return config;
}

export function refSlug(companyName) {
  return (companyName || "citehub").toLowerCase().replace(/[^a-z0-9]+/g, "").slice(0, 24) || "citehub";
}
